<template>
  <v-dialog :value="value" :max-width="maxWidth" @input="$emit('input', $event)">
    <v-card>
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <template v-if="fields.length">
          <h4 class="mb-1">{{ fieldsLabel }}</h4>
          <ul class="mb-3">
            <li v-for="field in fields" :key="field.value">
              <strong>{{ field.text }}</strong>
              —
              <code>{{ field.value }}</code>
            </li>
          </ul>
        </template>

        <template v-if="operators.length">
          <h4 class="mb-1">{{ operatorsLabel }}</h4>
          <ul class="mb-3">
            <li v-for="operator in operators" :key="operator.value">
              <strong>{{ operator.text }}</strong>
              —
              <code>{{ operator.value }}</code>
              <em v-if="operator.multiValue">({{ multiValueLabel }})</em>
            </li>
          </ul>
        </template>

        <template v-if="variables.length">
          <h4 class="mb-1">{{ variablesLabel }}</h4>
          <ul>
            <li v-for="variable in variables" :key="variable.value">
              <strong>{{ variable.text }}</strong>
              —
              <code>{{ variable.value }}</code>
              <template v-if="variable.description">: {{ variable.description }}</template>
            </li>
          </ul>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="$emit('input', false)">{{ closeLabel }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  /**
   * Reusable help modal for a condition builder: lists the available fields,
   * operators and variables of a filtering/condition context. Presentation only —
   * the caller supplies the data. Reusable across Triggers, Lists and the
   * orders-visibility settings; supports several variables (not just one).
   */
  export default {
    name: 'ConditionBuilderHelpDialog',
    props: {
      /** Dialog visibility (v-model). */
      value: {
        type: Boolean,
        default: false,
      },
      /** Dialog title (context specific, e.g. "Available fields, operators and variables"). */
      title: {
        type: String,
        required: true,
      },
      /** Selectable fields: [{ text, value }]. */
      fields: {
        type: Array,
        default: () => [],
      },
      /** Selectable operators: [{ text, value, multiValue }]. `multiValue` flags array operators. */
      operators: {
        type: Array,
        default: () => [],
      },
      /** Available variables: [{ text, value, description }]. Supports several entries. */
      variables: {
        type: Array,
        default: () => [],
      },
      maxWidth: {
        type: [Number, String],
        default: 640,
      },
      fieldsLabel: {
        type: String,
        default() {
          return this.$t('conditionBuilder.help.fields')
        },
      },
      operatorsLabel: {
        type: String,
        default() {
          return this.$t('conditionBuilder.help.operators')
        },
      },
      variablesLabel: {
        type: String,
        default() {
          return this.$t('conditionBuilder.help.variables')
        },
      },
      multiValueLabel: {
        type: String,
        default() {
          return this.$t('conditionBuilder.help.multiValue')
        },
      },
      closeLabel: {
        type: String,
        default() {
          return this.$t('conditionBuilder.help.close')
        },
      },
    },
  }
</script>
